<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>概览</el-breadcrumb-item>
    </el-breadcrumb>
    <el-main>
      <div class="websites_container">
        <el-card class="websites_dashboard">
          <el-row style="margin-bottom:10px">
            <el-col :span="6">
              <el-date-picker v-model="selectedYear" type="year" placeholder="选择年份" format="yyyy" value-format="yyyy"
                @change="drawChart1" />
            </el-col>
          </el-row>
          <div class="websites_echarts_box" id="chart1" v-loading="chart1Loading">

          </div>
          <div class="websites_echarts_box" id="chart2" v-loading="chart2Loading">

          </div>
        </el-card>
        <!-- <p class="text-extra-small">用 Element 快速搭建页面（辅助文字）</p>
            <p class="text-small">用 Element 快速搭建页面（正文小）</p>
            <p class="text-base">用 Element 快速搭建页面（正文）</p>
            <p class="text-medium">用 Element 快速搭建页面（小标题）</p>
            <p class="text-large">用 Element 快速搭建页面（标题）</p>
            <p class="text-extra-large">用 Element 快速搭建页面（主标题）</p> -->
        <div class="websites_operation_area">
          <el-card class="box-card" v-loading="websiteLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">站点</span>
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/list')">站点管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.website.total }}</span>
              </el-col>
              <el-col :span="8">
                开启: <span class="blue text-large">{{ statistics.website.on }}</span>
              </el-col>
              <el-col :span="8">
                关闭: <span class="red text-large">{{ statistics.website.off }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="domainLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">域名</span>
              <img src="../../../assets/imgs/tencent.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/domains')">域名管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.domain.total }}</span>
              </el-col>
              <el-col :span="8">
                自动续费: <span class="blue text-large">{{ statistics.domain.auto_renew }}</span>
              </el-col>
              <el-col :span="8">
                即将到期: <span class="red text-large">{{ statistics.domain.expired_in_month }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="dnspodLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">域名托管</span>
              <img src="../../../assets/imgs/tencent.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;"
                @click="$router.push('/websites/dnspod')">解析管理</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.dnspod.total }}</span>
              </el-col>
              <el-col :span="8">
                正常: <span class="blue text-large">{{ statistics.dnspod.normal }}</span>
              </el-col>
              <el-col :span="8">
                异常: <span class="red text-large">{{ statistics.dnspod.error }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="sslLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">证书</span>
              <img src="../../../assets/imgs/centos.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;" @click="getSslStatistics()">刷新</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.ssl.total }}</span>
              </el-col>
              <el-col :span="8">
                近期更新: <span class="blue text-large">{{ statistics.ssl.recent_updated }}</span>
              </el-col>
              <el-col :span="8">
                即将到期: <span class="red text-large">{{ statistics.ssl.expired_in_month }}</span>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-loading="deployLoading">
            <div slot="header" class="clearfix">
              <span class="text-base">部署情况</span>
              <img src="../../../assets/imgs/aliyun.png" alt="" class="cloud_logo">
              <el-button type="primary" size="mini" style="float: right;" @click="getDeployStatistics()">刷新</el-button>
            </div>
            <el-row class="text-small">
              <el-col :span="8">
                总数: <span class="blue text-large">{{ statistics.deploy.total }}</span>
              </el-col>
              <el-col :span="8">
                成功: <span class="blue text-large">{{ statistics.deploy.success }}</span>
              </el-col>
              <el-col :span="8">
                失败: <span class="red text-large">{{ statistics.deploy.failed }}</span>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
import * as echarts from 'echarts'
const today = new Date()
const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)
export default {
  name: 'Websites',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      websiteLoading: true,
      domainLoading: true,
      dnspodLoading: true,
      sslLoading: true,
      deployLoading: true,
      statistics: {
        website: {
          total: '-',
          on: '-',
          off: '-'
        },
        domain: {
          total: '-',
          auto_renew: '-',
          expired_in_month: '-'
        },
        dnspod: {
          total: '-',
          normal: '-',
          error: '-'
        },
        ssl: {
          total: '-',
          recent_updated: '-',
          expired_in_month: '-'
        },
        deploy: {
          total: '-',
          success: '-',
          failed: '-'
        }
      },
      selectedYear: new Date().getFullYear().toString(),
      chart1Loading: true,
      chart2Date: {
        year: yesterday.getFullYear(),
        month: yesterday.getMonth() + 1,
        day: yesterday.getDate()
      },
      chart2Loading: true
    }
  },
  async mounted() {
    await Promise.all([
      this.getWebsiteStatistics(),
      this.getDomainStatistics(),
      this.getDnspodStatistics(),
      this.getSslStatistics(),
      this.getDeployStatistics()
    ]);
    this.drawChart1();
    this.drawChart2();
  },
  methods: {
    getWebsiteStatistics() {
      this.websiteLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=website`).then((response) => {
        this.websiteLoading = false;
        if (response.data.code === 200) {
          this.statistics.website = response.data.data;
        }
      });
    },
    getDomainStatistics() {
      this.domainLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=domain`).then((response) => {
        this.domainLoading = false;
        if (response.data.code === 200) {
          this.statistics.domain = response.data.data;
        }
      });
    },
    getDnspodStatistics() {
      this.dnspodLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=dnspod`).then((response) => {
        this.dnspodLoading = false;
        if (response.data.code === 200) {
          this.statistics.dnspod = response.data.data;
        }
      });
    },
    getSslStatistics() {
      this.sslLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=ssl`).then((response) => {
        this.sslLoading = false;
        if (response.data.code === 200) {
          this.statistics.ssl = response.data.data;
        }
      });
    },
    getDeployStatistics() {
      this.deployLoading = true;
      this.$axios.get(`/websites/backend/statistics?type=deploy`).then((response) => {
        this.deployLoading = false;
        if (response.data.code === 200) {
          this.statistics.deploy = response.data.data;
        }
      });
    },
    async drawChart1() {
      const dom = document.getElementById('chart1')
      if (!this.chart1) {
        this.chart1 = this.$echarts.init(dom)
      }
      const year = this.selectedYear
      await this.$axios.get(`/websites/backend/statistics?type=cdn_traffic&year=${year}`).then((res) => {
        this.chart1Loading = false
        if (res.data.code === 200) {
          const values = res.data.data.map(v => v[1])
          let option1 = {
            title: {
              text: '年度流量一览(单位: byte)',
              left: 'left',
              top: 0
            },
            tooltip: {
              position: 'top'
            },
            visualMap: {
              min: 0,
              max: Math.max(...values),
              calculable: true,
              orient: 'horizontal',
              left: 'right',
              top: 0,
              itemHeight: 600,
              inRange: {
                color: [
                  '#eef2fb',
                  '#d8e1f5',
                  '#c0cdea',
                  '#9fb2de',
                  '#7c97d3',
                  '#5a7ec7',
                  '#3f66b9'
                ]
              }
            },
            calendar: [
              {
                top: 80,
                range: year,
                cellSize: ['auto', 20]
              }
            ],
            series: [
              {
                type: 'heatmap',
                coordinateSystem: 'calendar',
                calendarIndex: 0,
                data: res.data.data
              }
            ]
          }
          this.chart1.setOption(option1)
          this.bindChartClick()
        }
      });
    },
    bindChartClick() {
      this.chart1.off('click')
      this.chart1.on('click', (params) => {
        const date = params.value[0]
        const value = params.value[1]
        const d = new Date(date)
        const payload = {
          type: 'day',
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          day: d.getDate(),
          value: value
        }
        this.chart2Date = {
          year: payload.year,
          month: payload.month,
          day: payload.day
        };
        setTimeout(() => {
          this.drawChart2()
        }, 0);
      })
    },
    async drawChart2() {
      const dom = document.getElementById('chart2')
      if (!this.chart2) {
        this.chart2 = this.$echarts.init(dom)
      }
      let year = this.chart2Date.year;
      let month = this.chart2Date.month;
      let day = this.chart2Date.day;
      await this.$axios.get(`/websites/backend/statistics/detail?type=cdn_traffic&year=${year}&month=${month}&day=${day}`).then((res) => {
        this.chart2Loading = false
        if (res.data.code === 200) {
          const data = res.data.data;
          let option2 = {
            title: {
              text: year + '年' + month + '月' + day + '日 分时流量(单位: byte)',
              left: 10,
              top: 20
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: false
                },
                saveAsImage: {
                  pixelRatio: 2
                }
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              bottom: 90
            },
            dataZoom: [
              {
                type: 'inside'
              },
              {
                type: 'slider'
              }
            ],
            xAxis: {
              data: data.categoryData,
              silent: false,
              splitLine: {
                show: false
              },
              splitArea: {
                show: false
              }
            },
            yAxis: {
              splitArea: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                data: data.valueData,
                large: true
              }
            ]
          };
          this.chart2.setOption(option2)
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.websites_container {
  width: 98%;
  height: 80vh;
  overflow: auto;
  display: flex;
  justify-content: space-between;
}

.websites_dashboard {
  width: 78%;
  height: 668px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.websites_operation_area {
  width: 20%;
}

.box-card {
  margin-bottom: 20px;
}

.websites_echarts_box {
  width: 100%;
}

.cloud_logo {
  transform: translateY(1px);
  height: 12px;
}

#chart1 {
  height: 230px;
}

#chart2 {
  height: 350px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Index.vue